import { render, staticRenderFns } from "./PermissionProvide.vue?vue&type=template&id=e1e6327a&scoped=true"
import script from "./PermissionProvide.vue?vue&type=script&lang=js"
export * from "./PermissionProvide.vue?vue&type=script&lang=js"
import style0 from "./PermissionProvide.vue?vue&type=style&index=0&id=e1e6327a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1e6327a",
  null
  
)

export default component.exports